import { render, staticRenderFns } from "./ResearchView.vue?vue&type=template&id=5cf2ed1d&scoped=true&"
import script from "./ResearchView.vue?vue&type=script&lang=js&"
export * from "./ResearchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2ed1d",
  null
  
)

export default component.exports